// extracted by mini-css-extract-plugin
export default {"container":"container--x72g+zGssO","selection":"selection--1sIfZsGxj7"};